
import { URL_PHP } from "../../../Web_General/js/master_globals.js";


let FORGOT_ALREADY_SENT = false;



export async function forgotPassword(form, btn){

  const msg = document.getElementById("forgotMsg");

  // 📥 obtener email del form
  const email = form.querySelector('input[name="email"]')?.value.trim();

  // ❌ validación: vacío
  if (!email) {
    msg.textContent = "Please enter your email.";
    return;
  }

  // ❌ validación: formato básico
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    msg.textContent = "Invalid email format.";
    return;
  }

  // 🚫 evitar múltiples ejecuciones
  if (FORGOT_ALREADY_SENT) return;
  FORGOT_ALREADY_SENT = true;

  // 🔒 bloquear botón
  btn.disabled = true;

  msg.textContent = "Sending...";

  try {
    await postForm('https://divantys.com/Index/forgot_password', form);
    msg.textContent = "If the email exists, you will receive instructions.";
  } catch {
    msg.textContent = "Server error.";
    btn.disabled = false;          // 🔁 permitir reintento
    FORGOT_ALREADY_SENT = false;   // 🔁 permitir reintento
  }
}




export async function postForm(url, form){

  const res = await fetch(url,{
    method:"POST",
    body:new FormData(form)
  });

  console.log("STATUS:", res.status);

  const text = await res.text();

  console.log("RAW RESPONSE:");
  console.log(text);

  try{
    return JSON.parse(text);
  }catch(e){
    console.error("JSON PARSE ERROR:", e);
    throw e;
  }
}






// ==========================================================
// RESERVA COMPLETA (ALTA EN BASE DE DATOS LOCAL)
// Se llama al cerrar el form. Se removieron los bloqueos estrictos de Stripe tokens de este punto.
// ==========================================================
export async function alta_reserva_localstorage(statusPayment = "pending"){

  const data_send = {
    amount: localStorage.getItem("monto") || "0",
    email: localStorage.getItem("email"),
    username: localStorage.getItem("username"),
    password: localStorage.getItem("password"),
    plan: localStorage.getItem("plan_seleccionado") || "ninguno",

    key_payment: localStorage.getItem("key_payment"),
    payment_intent_id: localStorage.getItem("payment_intent_id") || "",

    // Valores dinámicos que se guardan en el estado inicial de la petición
    subscription_id: localStorage.getItem("subscription_id") || "",
    customer_id: localStorage.getItem("customer_id") || ""
  };

  console.log("send::" + JSON.stringify(data_send));

  let res;
  try {
    res = await fetch(
      URL_PHP + "Index/nuevo_user/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data_send)
      }
    );
  } catch (networkErr) {
    // Captura errores de conexión (ej. sin internet, servidor apagado)
    return { success: false, error: "NETWORK_ERROR", message: networkErr.message };
  }

  let data;
  try {
    data = await res.json();
    console.log("res::" + JSON.stringify(data));
  }
  catch (err) {
    const txt = await res.text();
    return { success: false, error: "SERVER_ERROR", message: txt };
  }

  // ============================
  // MANEJO DE ERRORES DEL BACKEND
  // ============================
  if (data.success !== 1) {
    return { 
      success: false, 
      error: data.error || "UNKNOWN_ERROR", 
      message: data.message || "Ocurrió un error inesperado en el servidor." 
    };
  }

  // ============================
  // REGISTRO EXITOSO
  // ============================
  localStorage.setItem("RESERVA_FINALIZADA", "1");

  // Limpiar datos sensibles
  localStorage.removeItem("password");

  return { success: true };
}











export async function nueva_suscription(statusPayment = "pending"){

  const data_send = {
    amount: localStorage.getItem("monto") || "0",
    email: localStorage.getItem("email"),
    username: localStorage.getItem("username"),
    password: localStorage.getItem("password"),
    plan: localStorage.getItem("plan_seleccionado") || "ninguno",

    key_payment: localStorage.getItem("key_payment"),
    payment_intent_id: localStorage.getItem("payment_intent_id") || "",

    // Valores dinámicos que se guardan en el estado inicial de la petición
    subscription_id: localStorage.getItem("subscription_id") || "",
    customer_id: localStorage.getItem("customer_id") || ""
  };

  console.log("send::" + JSON.stringify(data_send));

  let res;
  try {
    res = await fetch(
      URL_PHP + "Index/nueva_suscription/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data_send)
      }
    );
  } catch (networkErr) {
    // Captura errores de conexión (ej. sin internet, servidor apagado)
    return { success: false, error: "NETWORK_ERROR", message: networkErr.message };
  }

  let data;
  try {
    data = await res.json();
    console.log("res::" + JSON.stringify(data));
  }
  catch (err) {
    const txt = await res.text();
    return { success: false, error: "SERVER_ERROR", message: txt };
  }

  // ============================
  // MANEJO DE ERRORES DEL BACKEND
  // ============================
  if (data.success !== 1) {
    return { 
      success: false, 
      error: data.error || "UNKNOWN_ERROR", 
      message: data.message || "Ocurrió un error inesperado en el servidor." 
    };
  }

  // ============================
  // REGISTRO EXITOSO
  // ============================
  localStorage.setItem("RESERVA_FINALIZADA", "1");

  // Limpiar datos sensibles
  localStorage.removeItem("password");

  return { success: true };
}